module.exports = __webpack_public_path__ + "static/media/logo_wl.76848c14.png";